import { FileInputArea } from "@/components/flow/build/Steps/Upload/VisualAreaContent/FileInputArea";
import { ModalWithIcon } from "@scripts/react/components/RfModal/ModalWithIcon";
import { MediaItem } from "@/types/media";

const Modal = ModalWithIcon as any;

interface FileUploadModalProps {
    isModalOpen: boolean;
    setIsModalOpen: (isOpen: boolean) => void;
    onAddMediaItems: (files: File[]) => void;
    title: string;
    erroredMediaItems?: MediaItem[];
}

export const FileUploadModal = ({
    isModalOpen,
    setIsModalOpen,
    onAddMediaItems,
    title,
    erroredMediaItems = []
}: FileUploadModalProps) => {
    return (
        <Modal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            type="info"
            size="xl"
            icon="fad fa-upload"
            title={title}
            showFooter={false}
        >
            <FileInputArea
                addMediaItems={onAddMediaItems}
                erroredMediaItems={erroredMediaItems}
                qrSize={90}
                showAllMethods={true}
            />
        </Modal>
    );
};
